export default "/assets/webshop/img/iqoniq.jpg?ad9464f9730b5a6739285604119119a4";